export default __webpack_public_path__ + "logo01b4b4aa.png";